(function () {
  'use strict';
  const E=window.MelipronFitment;
  const labels=JSON.parse(document.getElementById('mp-vehicle-labels')?.textContent||'{}');
  const t=key=>labels[key]||key;
  const caches=new Map(),storageKey='melipron-van-v2';
  function loadCatalog(path){
    if(caches.has(path))return caches.get(path);
    const request=(async()=>{
      let url=new URL(path,location.origin),products=[],filterEnabled=false;
      url.searchParams.set('section_id','melipron-van-data');
      const preview=new URL(location.href).searchParams.get('preview_theme_id');
      if(preview)url.searchParams.set('preview_theme_id',preview);
      const visited=new Set();
      while(url){
        if(url.origin!==location.origin||visited.has(url.href))throw new Error('Invalid catalog pagination');
        visited.add(url.href);
        const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'},signal:AbortSignal.timeout(20000)});
        if(!response.ok)throw new Error('Catalog unavailable');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const node=doc.querySelector('[data-mp-van-catalog]');
        if(!node)throw new Error('Missing catalog section');
        const data=JSON.parse(node.textContent);
        products.push(...data.products);filterEnabled=filterEnabled||data.filterEnabled;
        url=data.next?new URL(data.next,location.origin):null;
        if(url){url.searchParams.set('section_id','melipron-van-data');if(preview)url.searchParams.set('preview_theme_id',preview);}
      }
      return{products,filterEnabled};
    })();
    caches.set(path,request);request.catch(()=>caches.delete(path));return request;
  }
  function savedVan(){try{const saved=JSON.parse(localStorage.getItem(storageKey));return saved?.expires>Date.now()?saved.vehicle:{};}catch{return{};}}
  function updateGarage(){
    const van=savedVan(),text=van.make&&van.model&&van.year?`${van.make} ${van.model} · ${van.year}`:t('select_van');
    document.querySelectorAll('[data-mp-open-van]').forEach(button=>{button.querySelector('[data-mp-nav-vehicle]').textContent=text;button.title=text;button.setAttribute('aria-label',`${t('change_van')}: ${text}`);});
  }
  function saveVan(vehicle,source){
    const value=Object.fromEntries(['make','model','year','roof','length','series'].map(key=>[key,vehicle[key]||'']));
    try{localStorage.setItem(storageKey,JSON.stringify({expires:Date.now()+90*86400000,vehicle:value}));}catch{}
    updateGarage();window.dispatchEvent(new CustomEvent('mp:van-change',{detail:{vehicle:value,source}}));
  }
  function status(root,state,title,messages,link){
    const node=root.querySelector('[data-mp-status]');node.replaceChildren();node.hidden=false;node.dataset.state=state;
    if(title){const strong=document.createElement('strong');strong.textContent=title;node.append(strong);}
    for(const message of messages.filter(Boolean)){const p=document.createElement('p');p.textContent=message;node.append(p);}
    if(link){const a=document.createElement('a');a.href=link;a.textContent=t('shop_this_vehicle');node.append(a);}
  }
  function options(select,values,chosen,placeholder){
    const signature=JSON.stringify([values,placeholder]);
    if(select.dataset.options!==signature){select.replaceChildren(new Option(placeholder,''),...values.map(v=>new Option(v,v)));select.dataset.options=signature;}
    select.value=values.includes(String(chosen))?chosen:'';select.disabled=!values.length;return select.value;
  }
  async function init(root){
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const form=root.querySelector('[data-mp-form]'),productMode=root.dataset.mode==='product';
    const fields=Object.fromEntries(Array.from(form.elements).filter(el=>el.name).map(el=>[el.name,el]));
    const product=JSON.parse(root.querySelector('[data-mp-product]')?.textContent||'null');
    let catalog;
    try{catalog=await loadCatalog(root.dataset.catalogUrl);}catch{if(product)catalog={products:[product],filterEnabled:false};else{status(root,'review',t('load_error'),[t('ask_support')]);return;}}
    const products=catalog.products,allRows=products.flatMap(E.rows),params=new URL(location.href).searchParams;
    let vehicle=params.has('filter.p.m.fitment.ymm')&&params.has('mp_make')?{make:params.get('mp_make'),model:params.get('mp_model'),year:params.get('mp_year')}:savedVan();
    let variantId=root.dataset.variant,variantValid=true;
    const productSection=root.closest('[id^="shopify-section-"]');
    if(productMode&&product.conditions){root.querySelector('[data-mp-conditions]').hidden=false;root.querySelector('[data-mp-conditions-text]').textContent=product.conditions;}
    function updateVariantBox(){
      const node=productSection?.querySelector('[data-mp-variant-requirements]');
      if(!node)return;
      const variant=(product.variants||[]).find(v=>String(v.id)===String(variantId));
      const parts=[];
      if(variant?.title&&variant.title!=='Default Title')parts.push(variant.title);
      if(variant?.roofs?.length)parts.push(`${t('roof')}: ${variant.roofs.join(' / ')}`);
      if(variant?.lengths?.length)parts.push(`${t('length')}: ${variant.lengths.join(' / ')}`);
      node.hidden=!parts.length;node.textContent=parts.length?`${t('selected_option')}: ${parts.join(' · ')}`:'';
    }
    function refresh(){
      vehicle.make=options(fields.make,E.unique(allRows.map(r=>r.make)).sort(),vehicle.make,t('choose_make'));
      vehicle.model=options(fields.model,E.unique(allRows.filter(r=>r.make===vehicle.make).map(r=>r.model)).sort(),vehicle.model,t('choose_model'));
      const modelRows=allRows.filter(r=>r.make===vehicle.make&&r.model===vehicle.model);let years=[];
      if(modelRows.length){
        const starts=modelRows.filter(r=>!r.unknown&&!r.all).map(r=>r.from),currentYear=new Date().getFullYear();
        const first=modelRows.some(r=>r.all||r.unknown)?1900:(starts.length?Math.min(...starts):1900),last=Math.max(currentYear+1,...modelRows.filter(r=>r.to).map(r=>r.to));
        for(let y=last;y>=first;y--)if(modelRows.some(r=>r.all||r.unknown||(y>=r.from&&(!r.to||y<=r.to))))years.push(String(y));
      }
      vehicle.year=options(fields.year,years,vehicle.year,t('choose_year'));
      root.querySelector('[data-mp-submit]').disabled=!vehicle.year||(!productMode&&!catalog.filterEnabled);
      if(productMode){
        const universal=E.isUniversal(product),required=E.requirements(product,vehicle,variantId);
        for(const[field,key]of[['roof','roofs'],['length','lengths'],['series','series']]){
          const supported=required[field]||[];
          const alternatives=field==='roof'?['Low','Medium','High','Super High']:[];
          const values=E.unique(E.optionValues(products,vehicle,field).concat(supported,alternatives,vehicle[field]||[],'Other')).sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
          vehicle[field]=options(fields[field],values,vehicle[field],t('not_sure'));
          fields[field].closest('label').hidden=!supported.length||universal;
          fields[field].required=!universal&&!!supported.length;
        }
        root.querySelector('[data-mp-details]').hidden=!vehicle.model||universal;updateVariantBox();
      }
      const saved=root.querySelector('[data-mp-saved]');if(saved)saved.textContent=vehicle.year?`${vehicle.make} ${vehicle.model} · ${vehicle.year}`:'';
    }
    function check(){
      if(!productMode||!vehicle.year)return;
      if(!variantValid){status(root,'review',t('status_review'),[t('reason_variant')]);return;}
      const required=['roof','length','series'].filter(key=>fields[key]?.required);
      const result=E.assess(product,vehicle,variantId,fields.confirmed.checked,required);
      const messages=result.reasons.map(t).concat(result.notes||[]);
      if(result.state==='fit')messages.push(t('match_note'));
      const state=result.missing?.length?'pending':result.state;
      const link=catalog.filterEnabled?E.collectionUrl(root.dataset.target,products,vehicle,location.href):null;
      status(root,state,t('status_'+state),messages,link);
    }
    refresh();if(vehicle.year)saveVan(vehicle,root);
    if(!catalog.filterEnabled&&!productMode)status(root,'review',t('load_error'),[t('filter_unavailable')]);
    if(productMode&&vehicle.year)check();
    form.addEventListener('change',event=>{
      const key=event.target.name;if(key==='confirmed'){check();return;}
      vehicle[key]=event.target.value;
      if(key==='make'){vehicle.model='';vehicle.year='';}
      if(key==='make'||key==='model')for(const k of['roof','length','series'])vehicle[k]='';
      if(fields.confirmed)fields.confirmed.checked=false;root.querySelector('[data-mp-status]').hidden=true;
      refresh();if(vehicle.year){saveVan(vehicle,root);check();}
    });
    form.addEventListener('submit',event=>{
      event.preventDefault();if(!form.reportValidity())return;saveVan(vehicle,root);
      if(productMode){check();return;}if(!catalog.filterEnabled)return;
      const destination=E.collectionUrl(root.dataset.target,products,vehicle,location.href);
      if(destination)location.assign(destination);else status(root,'review',t('no_matches'),[t('ask_support')]);
    });
    root.querySelector('[data-mp-reset]')?.addEventListener('click',()=>{
      try{localStorage.removeItem(storageKey);}catch{}vehicle={};if(fields.confirmed)fields.confirmed.checked=false;
      refresh();root.querySelector('[data-mp-status]').hidden=true;updateGarage();window.dispatchEvent(new CustomEvent('mp:van-change',{detail:{vehicle:{},source:root}}));
      if(!productMode&&new URL(location.href).searchParams.has('filter.p.m.fitment.ymm')){
        const clean=new URL(location.href);for(const key of['filter.p.m.fitment.ymm','mp_make','mp_model','mp_year','page'])clean.searchParams.delete(key);location.assign(clean.href);
      }
    });
    window.addEventListener('mp:van-change',event=>{
      if(!root.isConnected||event.detail.source===root)return;
      vehicle={...event.detail.vehicle};if(fields.confirmed)fields.confirmed.checked=false;
      refresh();root.querySelector('[data-mp-status]').hidden=true;check();
    });
    if(productMode)document.addEventListener('on:variant:change',event=>{
      if(!root.isConnected||(event.target!==document&&productSection&&!productSection.contains(event.target)))return;
      if(event.detail&&Object.hasOwn(event.detail,'variant')&&!event.detail.variant){variantValid=false;fields.confirmed.checked=false;check();return;}
      const nextId=event.detail?.variant?.id||productSection?.querySelector('.js-product-form-main [name="id"]')?.value;
      if(!nextId)return;
      variantValid=true;if(String(nextId)===String(variantId))return;
      variantId=nextId;fields.confirmed.checked=false;refresh();check();
    });
  }
  const safeInit=root=>init(root).catch(()=>status(root,'review',t('load_error'),[t('ask_support')]));
  const mount=()=>{document.querySelectorAll('[data-mp-vehicle]').forEach(root=>{if(root.dataset.presentation!=='modal')safeInit(root);});updateGarage();};
  const dialog=document.getElementById('mp-van-dialog');let opener;
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-mp-open-van]');
    if(trigger&&dialog){opener=trigger;dialog.showModal();document.querySelectorAll('[data-mp-open-van]').forEach(b=>b.setAttribute('aria-expanded','true'));const root=dialog.querySelector('[data-mp-vehicle]');safeInit(root).then(()=>{if(dialog.open)root.querySelector('select[name="make"]')?.focus();});}
    if(event.target.closest('[data-mp-close-van]'))dialog?.close();
    if(event.target===dialog)dialog.close();
  });
  dialog?.addEventListener('close',()=>{document.querySelectorAll('[data-mp-open-van]').forEach(b=>b.setAttribute('aria-expanded','false'));opener?.focus({preventScroll:true});});
  function updateNativeCount(){const count=document.querySelector('[data-mp-native-count]'),heading=document.querySelector('.collection-banner__count');if(count&&heading)heading.textContent='('+count.dataset.label+')';}
  mount();updateNativeCount();document.addEventListener('shopify:section:load',mount);
  document.addEventListener('on:facet-filters:updated',()=>{
    updateNativeCount();const facets=document.getElementById('facets');if(!facets)return;
    const key='filter.p.m.fitment.ymm';facets.querySelectorAll('input[type="hidden"][name="'+key+'"]').forEach(el=>el.remove());
    const values=new URL(location.href).searchParams.getAll(key).flatMap(value=>value.split(','));
    for(const value of E.unique(values)){const input=document.createElement('input');input.type='hidden';input.name=key;input.value=value;facets.append(input);}
  });
})();

;(function () {
  'use strict';
  const pageCache=new Map();
  let observedRoot,observer,scheduled=false,revision=0,activeController,activeKey;
  function eligible(url){return url.pathname.includes('/collections/')&&(url.searchParams.has('filter.p.m.fitment.ymm')||url.pathname.endsWith('/universal-van-accessories'));}
  function contextUrl(value){const url=new URL(value,location.origin);for(const key of ['page','section_id','mp_make','mp_model','mp_year'])url.searchParams.delete(key);url.searchParams.sort();return url.href;}
  function pageNumber(url){return Math.max(1,Number(new URL(url,location.origin).searchParams.get('page'))||1);}
  function extract(root){
    const grid=root.querySelector('ul.grid[role="list"]');
    const items=grid?Array.from(grid.children).filter(el=>el.querySelector('product-card')):[];
    return{grid,items,records:items.map(item=>{
      const card=item.querySelector('product-card'),state=card.dataset.mpAvailable;
      if(!card.dataset.mpProductId||!['true','false'].includes(state))throw new Error('Missing stock information');
      return{id:card.dataset.mpProductId,available:state==='true',item};
    })};
  }
  async function loadPages(url,seed,signal){
    const pages=new Map(),visited=new Set(),first=new URL(url);first.searchParams.set('page','1');
    const queue=[first];
    function addLinks(root){
      for(const link of root.querySelectorAll('.js-pagination a[href]')){
        const next=new URL(link.getAttribute('href'),url);
        if(next.origin===location.origin&&contextUrl(next)===contextUrl(url)&&!visited.has(pageNumber(next)))queue.push(next);
      }
    }
    addLinks(seed);
    while(queue.length){
      const batch=[];
      while(queue.length&&batch.length<3){const next=queue.shift(),number=pageNumber(next);if(!visited.has(number)){visited.add(number);batch.push({url:next,number});}}
      const loaded=await Promise.all(batch.map(async entry=>{
        const section=seed.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-','');
        const request=new URL(entry.url);if(section)request.searchParams.set('section_id',section);
        const response=await fetch(request,{credentials:'same-origin',signal:AbortSignal.any([signal,AbortSignal.timeout(15000)]),headers:{Accept:'text/html'}});
        if(!response.ok)throw new Error('Stock ordering request failed');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html'),root=doc.getElementById('filter-results');
        if(!root)throw new Error('Missing result page');
        return{number:entry.number,root,result:extract(root)};
      }));
      for(const entry of loaded){pages.set(entry.number,entry.result);addLinks(entry.root);}
    }
    const orderedPages=Array.from(pages).sort((a,b)=>a[0]-b[0]);
    if(!pages.has(1)||orderedPages.some(([number],i)=>number!==i+1))throw new Error('Incomplete result pages');
    const records=orderedPages.flatMap(([,page])=>page.records),ids=new Set(records.map(record=>record.id));
    if(ids.size!==records.length)throw new Error('Duplicate result products');
    return{perPage:pages.get(1).records.length,records:records.filter(record=>record.available).concat(records.filter(record=>!record.available))};
  }
  function observe(root){
    observer?.disconnect();observedRoot=root;
    observer=new MutationObserver(changes=>{
      if(changes.some(change=>Array.from(change.addedNodes).concat(Array.from(change.removedNodes)).some(node=>node.nodeType===1&&(node.matches('li.js-pagination-result,ul.grid')||node.querySelector('product-card')))))schedule();
    });
    observer.observe(root,{childList:true,subtree:true});
  }
  async function reorder(){
    const url=new URL(location.href),root=document.getElementById('filter-results');
    if(!root||!eligible(url))return;
    if(observedRoot!==root)observe(root);
    let current;
    try{current=extract(root);}catch{return;}
    if(!current.records.length)return;
    const key=contextUrl(url),signature=current.records.map(record=>record.id).join(',');
    if(current.grid.dataset.mpStockOrder===key+'|'+signature)return;
    const run=++revision;
    if(activeKey!==key||!activeController||activeController.signal.aborted){activeController?.abort();activeController=new AbortController();activeKey=key;}
    root.setAttribute('aria-busy','true');
    try{
      let cached=pageCache.get(key);
      if(!cached||Date.now()-cached.created>30000){
        const promise=loadPages(url,root,activeController.signal);cached={created:Date.now(),promise};pageCache.set(key,cached);
        promise.catch(()=>{if(pageCache.get(key)?.promise===promise)pageCache.delete(key);});
      }
      const data=await cached.promise;
      if(run!==revision||!root.isConnected||contextUrl(location.href)!==key||!current.grid.isConnected)return;
      const visible=extract(root),offset=(pageNumber(url)-1)*data.perPage,desired=data.records.slice(offset,offset+visible.items.length);
      if(desired.length!==visible.items.length)throw new Error('Result size changed');
      observer.disconnect();
      visible.items.forEach((item,i)=>{if(visible.records[i].id!==desired[i].id||visible.records[i].available!==desired[i].available)item.replaceWith(document.importNode(desired[i].item,true));});
      visible.grid.dataset.mpStockOrder=key+'|'+desired.map(record=>record.id).join(',');
      observe(root);window.initLazyImages?.();
      const pagination=root.closest('custom-pagination');if(pagination)pagination.results=pagination.querySelectorAll('.js-pagination-result');
    }catch(error){if(error.name!=='AbortError')console.warn('Stock priority could not be applied',error.message);}
    finally{if(run===revision)root.removeAttribute('aria-busy');}
  }
  function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;reorder();});}}
  document.addEventListener('on:facet-filters:updated',schedule);
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('on:bfcache:load-restore',()=>{pageCache.clear();schedule();});
  window.addEventListener('pagehide',()=>activeController?.abort());
  schedule();
})();
